import ContactAndShipping from './ContactAndShipping';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import when from 'recompose/branch';
import lifecycle from 'recompose/lifecycle';
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
import formatPrismicData from '../../hocs/formatPrismicData';
import withGlobalContent from '../../hocs/withGlobalContent';
import withCountry from '../../hocs/withCountry';
import { getOrderDetails } from '../../../store/selectors/cart';
import { trackGeneralClick } from '../../../analytics/category/checkout';
import { buildContent, buildUrl } from './helpers';
import { withUserOrders } from '../../data-providers/orders';
import logger from '../../../../../logger';


const enhanceWithOrder = compose(
  withUserOrders,
  withGlobalContent,
  withState('orderDetails', 'setOrderDetails', { isLoading: true }),
  lifecycle({
    async componentDidMount() {
      const props = this.props;
      const orderNumber = props.match.params.orderNumber;
      try {
        const order = await props.fetchUserOrder(orderNumber);
        const { firstName, lastName, address1, address2, zipcode, city, country_iso: country, email } = order.shipping;
        const methodName = Object.keys(order.shipping.deliveryDate)[0];
        props.setOrderDetails({
          ...order.shipping,
          shippingAddress: {
            firstname: firstName,
            lastname: lastName,
            address1,
            address2,
            zipcode,
            city,
            country,
          },
          email,
          selectedShipment: {
            method: {
              name: capitalize(methodName),
              type: methodName,
            },
            delivery: order.shipping.deliveryDate[methodName]
          },
          isLoading: false,
        });
      } catch (err) {
        logger.error('Failed to fetch user order', err);
      }
    }
  }),
  withProps(({
    isVerticalLayout: true,
  }))
);

const enhanceWithCart = connect(state => ({
  orderDetails: getOrderDetails(state),
}));

const enhance = compose(
  formatPrismicData,
  withCountry,
  withRouter,
  withGlobalContent,
  when(props => props.dataFrom === 'order', enhanceWithOrder, enhanceWithCart),
  withProps(props => ({
    isLoading: get(props, 'orderDetails.isLoading', true),
    items: props.items.map(item => ({
      ...item,
      content: buildContent(item, props),
      url: buildUrl(item, props)
    }))
  })),
  withHandlers({
    handleOnClick: (props) => (event) => {
      const fieldType = event.target.getAttribute('data-field-type');
      const pathname = props.history.location.pathname;
      trackGeneralClick(`change ${fieldType}`, pathname);
    }
  })
);

export default enhance(ContactAndShipping);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ContactAndShipping/index.js